<h2 mat-dialog-title>Información</h2>
<mat-dialog-content>
    <p>Gracias. En breve nos pondremos en contacto con Ústed</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="accent" (click)="close()">
        Aceptar
    </button>
</mat-dialog-actions>
